import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { OxygenInstructionV2, OxygenMethod } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface OxygenInstructionFormGroup {
	percentageToGive: FormControl<UnitValue | null>;
	oxygenMethod: FormControl<OxygenMethod | null>;
}

@Component({
    selector: 'app-oxygen-item-form-v2',
    templateUrl: './oxygen-item-form-v2.component.html',
    styleUrl: './oxygen-item-form-v2.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, UnitValueControl, SelectControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OxygenItemFormComponentV2 implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
  	@Input() itemConfig!: ItemTypeMetadata;

	oxygenMethods: SelectItem[] = [
		{ text: 'CPAP', value: OxygenMethod.Cpap },
		{ text: 'High flow', value: OxygenMethod.HighFlow },
		{ text: 'Nasal prongs', value: OxygenMethod.NasalProngs },
		{ text: 'Oxygen kennel', value: OxygenMethod.OxygenKennel },
	];

	percentUnit = [{ label: '%', value: '%' }];


	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<OxygenInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const oxygenInstruction = instruction as OxygenInstructionV2;
			group.addControl('percentageToGive', this.formBuilder.control(oxygenInstruction.percentageToGive ?? null));
			group.addControl('oxygenMethod', this.formBuilder.control(oxygenInstruction.oxygenMethod ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<OxygenInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('percentageToGive', this.formBuilder.control(null));
		group.addControl('oxygenMethod', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}